export const CURRENT_ORGANIZATION_KEY = 'currentOrganization';

const ORGANIZATION_SCOPED_KEY_PATTERN = /^(org_|tenant_|organization_|amazon_|inventory_|product|products_|catalog_|supplier_|warehouse_|analytics_|dashboard_|fba_|movement|sync_|report_|order_|purchase_|stock_)/i;

const isProtectedStorageKey = (key) => {
  if (!key) return false;
  if (key === CURRENT_ORGANIZATION_KEY) return false;
  if (['access_token', 'refresh_token', 'user', 'theme', 'sidebarCollapsed', 'gabhan_voted_features', 'gabhan_cmd_history'].includes(key)) {
    return false;
  }

  return ORGANIZATION_SCOPED_KEY_PATTERN.test(key);
};

const dispatchOrganizationChange = (detail) => {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return;
  }

  window.dispatchEvent(new CustomEvent('organization-changed', { detail }));
};

export const clearOrganizationScopedState = (preserveKeys = []) => {
  const preserve = new Set(preserveKeys);

  const clearStorage = (storage) => {
    if (!storage || typeof storage.removeItem !== 'function') return;
    const keys = Object.keys(storage);
    keys.forEach((key) => {
      if (preserve.has(key) || !isProtectedStorageKey(key)) return;
      storage.removeItem(key);
    });
  };

  if (typeof localStorage !== 'undefined') clearStorage(localStorage);
  if (typeof sessionStorage !== 'undefined') clearStorage(sessionStorage);
};

export const getCurrentOrganizationId = () => {
  return localStorage.getItem(CURRENT_ORGANIZATION_KEY) || null;
};

export const setCurrentOrganizationId = (organizationId, options = {}) => {
  const { preserveKeys = [] } = options;
  if (!organizationId) {
    return null;
  }

  const previousOrganizationId = getCurrentOrganizationId();
  localStorage.setItem(CURRENT_ORGANIZATION_KEY, organizationId);

  if (previousOrganizationId && previousOrganizationId !== organizationId) {
    clearOrganizationScopedState(preserveKeys);
    dispatchOrganizationChange({ previousOrganizationId, organizationId });
  }

  if (!previousOrganizationId) {
    dispatchOrganizationChange({ previousOrganizationId: null, organizationId });
  }

  return organizationId;
};

export const appendOrganizationHeader = (config = {}) => {
  const nextConfig = { ...config, headers: { ...(config.headers || {}) } };
  const organizationId = getCurrentOrganizationId();

  if (organizationId) {
    nextConfig.headers['X-Organization-Id'] = organizationId;
  }

  return nextConfig;
};
